export default {"src":"/_next/static/media/recommended.e0928bc2.svg","height":38,"width":126,"blurWidth":0,"blurHeight":0};